/* @flow */
// typecheck: ignore file
import React from 'react';
import ReactDOM from 'react-dom';
import shallowCompare from 'react-addons-shallow-compare';

import RoleBasedMessagingGroupResultItem from 'chat/components/RoleBasedMessagingGroupResultItem.jsx';
import RoleBasedMessagingIndividualResultItem from 'chat/components/RoleBasedMessagingIndividualResultItem.jsx';
import { RECIPIENT_TYPES } from 'reducers/roleBasedMessagingSearch';

import type { Recipient } from 'reducers/roleBasedMessagingSearch';

import './styles/RoleBasedMessagingResultItem.scss';

type Props = {
  recipients: Recipient[],
  highlighted: bool,
  selectedRecipients: Recipient[],
  query: string,
  onSelect: (recipients: Recipient[]) => void,
  onMouseEnter: () => void,
  onMouseLeave: () => void,
  resultSelectionIndex: number,
  scrollIntoView: bool,
};

class RoleBasedMessagingResultItem extends React.Component {
  props: Props;

  static defaultProps = {
    scrollIntoView: false,
    onMouseEnter: () => {},
    onMouseLeave: () => {},
  }

  componentDidMount() {
    if (this.props.scrollIntoView) {
      setTimeout(() => { // Because parent ScrollableArea is async
        const node = ReactDOM.findDOMNode(this);
        const nodeBottom = node.offsetTop + node.offsetHeight;
        const scrollAreaBottom = node.offsetParent.scrollTop + node.offsetParent.offsetHeight;
        if (nodeBottom > scrollAreaBottom) {
          node.scrollIntoView();
        }
      }, 0);
    }
  }

  shouldComponentUpdate(nextProps: Props): bool {
    return shallowCompare(this, nextProps);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.highlighted && !prevProps.highlighted) {
      // Only scroll into view if the entire element is not visible, otherwise mouse hover would trigger scroll.
      const node = ReactDOM.findDOMNode(this);
      const nodeTop = node.offsetTop;
      const nodeBottom = nodeTop + node.offsetHeight;
      const scrollAreaTop = node.offsetParent.scrollTop;
      const scrollAreaBottom = scrollAreaTop + node.offsetParent.offsetHeight;
      if (nodeTop > scrollAreaBottom || nodeBottom < scrollAreaTop) {
        node.scrollIntoView();
      }
    }
  }

  render() {
    const { recipients, ...rest } = this.props;
    const groupRecipients = recipients.filter((r: Recipient) => r.type === RECIPIENT_TYPES.GROUP_RECIPIENT);
    const individualRecipients = recipients.filter((r: Recipient) => {
      return r.type === RECIPIENT_TYPES.INDIVIDUAL_RECIPIENT;
    });
    let content;

    if (groupRecipients.length) {
      content = (
        <RoleBasedMessagingGroupResultItem
          {...rest}
          recipients={groupRecipients}
        />
      );
    } else {
      const recipient = individualRecipients[0];
      if (recipient.type === RECIPIENT_TYPES.INDIVIDUAL_RECIPIENT) {
        content = (
          <RoleBasedMessagingIndividualResultItem
            {...rest}
            recipient={recipient}
          />
        );
      }
    }

    return (
      <div className="RoleBasedMessagingResultItem-container">
        {content}
      </div>
    );
  }
}

export default RoleBasedMessagingResultItem;



// WEBPACK FOOTER //
// ./src/chat/components/RoleBasedMessagingResultItem.jsx